module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/assessment_achievements/5@2x_8fdcc1bcf0302da6be8688657e24d7d1.png";